import { GoogleLogin } from '@react-oauth/google';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { loginWithGoogle } from '../api';

export default function LoginPage({ onLogin }) {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleGoogleSuccess = async (credentialResponse) => {
    setLoading(true);
    setError(null);
    try {
      const data = await loginWithGoogle(credentialResponse.credential);
      if (data.authenticated) {
        onLogin(data.user);
      } else {
        setError(data.error || 'Authentication failed');
      }
    } catch (err) {
      setError(err.message || 'Network error. Please try again.');
    }
    setLoading(false);
  };

  const handleEmailLogin = (e) => {
    e.preventDefault();
    setError('Account not found. Please check your credentials or create an account.');
  };

  return (
    <div style={s.page}>
      <div style={s.bgGlow} />
      <div style={s.card}>
        <Link to="/" style={s.backLink}>← Back</Link>
        <div style={s.logoWrap}>
          <img src="/logo_256.png" alt="Thankful Money" style={s.logo} />
        </div>
        <h1 style={s.title}>Welcome back</h1>
        <p style={s.subtitle}>Sign in to your account</p>

        <form onSubmit={handleEmailLogin} style={s.form}>
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={s.input}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={s.input}
          />
          <button type="submit" style={s.btn}>Sign In</button>
        </form>

        {loading && <p style={s.loading}>Verifying...</p>}
        {error && <p style={s.error}>{error}</p>}

        <div style={s.orDivider}>
          <span style={s.orLine} />
          <span style={s.orText}>or continue with</span>
          <span style={s.orLine} />
        </div>

        <div style={s.googleBtn}>
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={() => setError('Google sign-in failed')}
            theme="filled_black"
            size="large"
            width="308"
            text="signin_with"
          />
        </div>

        <div style={s.divider} />

        <p style={s.footerText}>
          Don't have an account? <Link to="/register" style={s.link}>Request access</Link>
        </p>

        <p style={s.legal}>
          By signing in, you agree to our{' '}
          <Link to="/terms" style={s.legalLink}>Terms</Link>,{' '}
          <Link to="/privacy" style={s.legalLink}>Privacy</Link>, and{' '}
          <Link to="/cybersecurity" style={s.legalLink}>Security Policy</Link>.
        </p>
      </div>
    </div>
  );
}

const s = {
  page: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    minHeight: '100vh', background: '#080d16', position: 'relative',
  },
  bgGlow: {
    position: 'absolute', top: '-100px', left: '50%', transform: 'translateX(-50%)',
    width: '800px', height: '400px',
    background: 'radial-gradient(ellipse at center, rgba(16,185,129,0.06) 0%, transparent 65%)',
    pointerEvents: 'none',
  },
  card: {
    width: 400, padding: '40px 36px', background: 'rgba(15,23,42,0.7)',
    borderRadius: 16, border: '1px solid #1e293b',
    textAlign: 'center', boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
    position: 'relative', zIndex: 1, backdropFilter: 'blur(8px)',
  },
  backLink: {
    position: 'absolute', top: 16, left: 20, fontSize: 12, color: '#6b7280',
    textDecoration: 'none', fontWeight: 500,
  },
  logoWrap: { marginBottom: 16 },
  logo: { width: 64, height: 64, objectFit: 'contain' },
  title: { fontSize: 24, fontWeight: 800, color: '#f9fafb', marginBottom: 4 },
  subtitle: { fontSize: 14, color: '#9ca3af', marginBottom: 28 },
  form: { display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 12 },
  input: {
    padding: '13px 16px', fontSize: 14, borderRadius: 8,
    border: '1px solid #1e293b', background: '#0f172a',
    color: '#f9fafb', outline: 'none', width: '100%', boxSizing: 'border-box',
    transition: 'border-color 0.15s',
  },
  btn: {
    padding: '13px 0', background: '#10b981', color: '#000',
    border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 700,
    cursor: 'pointer', marginTop: 4,
    boxShadow: '0 4px 16px rgba(16,185,129,0.2)',
  },
  loading: { fontSize: 13, color: '#9ca3af', marginTop: 8 },
  error: {
    fontSize: 13, color: '#f87171', marginTop: 12, padding: '10px 14px',
    background: 'rgba(248,113,113,0.08)', border: '1px solid rgba(248,113,113,0.2)',
    borderRadius: 8, textAlign: 'left',
  },
  orDivider: { display: 'flex', alignItems: 'center', gap: 12, margin: '20px 0' },
  orLine: { flex: 1, height: 1, background: '#1e293b' },
  orText: { fontSize: 11, color: '#6b7280', fontWeight: 500 },
  googleBtn: { display: 'flex', justifyContent: 'center', marginBottom: 8 },
  divider: { height: 1, background: '#1e293b', margin: '20px 0 16px' },
  footerText: { fontSize: 13, color: '#9ca3af', marginBottom: 12 },
  link: { color: '#10b981', textDecoration: 'none', fontWeight: 600 },
  legal: { fontSize: 11, color: '#4b5563', lineHeight: 1.6 },
  legalLink: { color: '#6b7280', textDecoration: 'underline' },
};
